module.exports = __webpack_public_path__ + "img/even-amundsen-untitled.bad5ecd.jpg";